import { Component, OnInit, Inject, AfterContentInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { Temporal } from '@js-temporal/polyfill';
import { EConsommableAir } from 'src/app/domain/Air/enum/consommable-air';
import { Consommable } from 'src/app/domain/consommable';
import { StringConverter } from '../string-converter';
import { EConsommableSurface } from 'src/app/domain/Surface/enum/consommable-surface';
import { EConsommableDialyse } from 'src/app/domain/Dialyse/enum/consommable-dialyse';
import { EServiceType } from 'src/app/domain/enums/service-type';
import { db } from 'src/app/db/db';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { EMilieuPrelevementAir } from 'src/app/domain/Air/enum/milieu-prelevement';
import { EMilieuPrelevementSurface } from 'src/app/domain/Surface/enum/milieu-prelevement';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InterventionRepository } from 'src/app/db/repository/intervention.repository';
import { Intervention } from 'src/app/domain/intervention';
import { Prelevement } from 'src/app/domain/prelevement';
import { PrelevementRepository } from 'src/app/db/repository/prelevement.repository';
import { ConsommableRepository } from 'src/app/db/repository/consommable.repository';

@Component({
    selector: 'app-consommable-box',
    templateUrl: './consommable-box.html',
    styleUrl: './consommable-box.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, FormsModule, MatOptionModule, MatInputModule, MatDatepickerModule, MatButtonModule, PreventDoubleClickDirective]
})
export class ConsommableBoxDialog implements OnInit, AfterContentInit {
    EServiceType = EServiceType;
    public ConsommableAirList: string[] = Object.values(EConsommableAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getConsommableAirLabel(x));
    public ConsommableSurfaceList: string[] = Object.values(EConsommableSurface)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getConsommableSurfaceLabel(x));
    public ConsommableDialyseList: string[] = Object.values(EConsommableDialyse)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getConsommableDialyseLabel(x));

    public Model: Consommable = new Consommable();
    public interventionTimeExpiration!: string;

    Expiration: Date = new Date();
    TypeOfService: EServiceType = EServiceType.Air;
    Milieu?: EMilieuPrelevementAir | EMilieuPrelevementSurface;
    interventionCode: string = '';
    private sameTypeOfServiceIntervenList: Intervention[] = [];
    prelevementList: Prelevement[] = []
    loadingAllAvailableConsommableFinished: boolean = false;

    constructor(
        private interventionRepository: InterventionRepository,
        private prelevementRepository: PrelevementRepository,
        private consommableRepository: ConsommableRepository,
        public dialogRef: MatDialogRef<ConsommableBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.TypeOfService = data.typeOfService;
            this.Milieu = data.milieu;
            this.interventionCode = data.interventionCode;
        }
        if (data.consommable) {

            this.Model = data.consommable
            this.Expiration = new Date(this.Model.Expiration!.year, this.Model.Expiration!.month - 1, this.Model.Expiration!.day)
        }
        else {

            this.Model.Expiration = Temporal.Now.plainDateISO();

            if (this.TypeOfService === EServiceType.Air) {
                this.Model.Type = this.getAirTypeByMilieu(this.Milieu as EMilieuPrelevementAir)
            } else if (this.TypeOfService === EServiceType.Surface) {
                this.Model.Type = this.getSurfaceTypeByMilieu(this.Milieu as EMilieuPrelevementSurface)
            }

            this.checkLastConsommable()
        }
    }

    ngOnInit() { }

    async ngAfterContentInit(): Promise<void> {

        switch (this.TypeOfService) {
            case EServiceType.Air:
                this.sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithZoneOnly();
                this.prelevementList = this.sameTypeOfServiceIntervenList.map(x => x.ZoneList.map(y => y.PrelevementAirList.map(z => z.Prelevement))).flat(2)
                break;
            case EServiceType.Surface:
                this.sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithZoneOnly();
                console.log(this.sameTypeOfServiceIntervenList)
                this.prelevementList = this.sameTypeOfServiceIntervenList.map(x => x.ZoneList.map(y => y.PrelevementSurfaceList.map(z => z.Prelevement))).flat(2)
                console.log(this.prelevementList.map(x => x.Code))
                break;
            // case EServiceType.Dialyse:
            //     this.sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithGenerateurOnly();
            //     this.prelevementList = this.sameTypeOfServiceIntervenList.map(x => x.GenerateurDialyseList.map(y => y.PrelevementGenerateurDialyseList.map(z => z.Prelevement))).flat(2)
            //     break;
            case EServiceType.Endoscope:
                this.sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithEndoscopeOnly();
                this.prelevementList = this.sameTypeOfServiceIntervenList.map(x => x.EndoscopeList.map(y => y.CanalEndoscopeList.map(z => z.Prelevement))).flat(2)
                break;
        }

        this.loadingAllAvailableConsommableFinished = true
    }

    getAirTypeByMilieu(milieu: EMilieuPrelevementAir) {
        switch (milieu) {
            case EMilieuPrelevementAir.PCA:
                return EConsommableAir.GelosePCA
            case EMilieuPrelevementAir.SAB:
                return EConsommableAir.GeloseSabouraud
            default:
                return -1
        }
    }

    getSurfaceTypeByMilieu(milieu: EMilieuPrelevementSurface) {
        switch (milieu) {
            case EMilieuPrelevementSurface.Lames:
                return EConsommableSurface.Bilame
            case EMilieuPrelevementSurface.Ecouvillons:
                return EConsommableSurface.Ecouvillon
            case EMilieuPrelevementSurface.BoiteContact:
                return EConsommableSurface.GeloseContact
            case EMilieuPrelevementSurface.Lingettes:
                return EConsommableSurface.Lingette
            default:
                return -1
        }
    }

    expirationChanged(event: MatDatepickerInputEvent<Date>) {

        this.Model!.Expiration = Temporal.PlainDate.from({ year: this.Expiration.getFullYear(), day: this.Expiration.getDate(), month: this.Expiration.getMonth() + 1 });
    }

    async checkLastConsommable() {
        const lc = await db.getLastUsedConsommableByType(this.Model.Type, this.TypeOfService)

        if (lc) {
            this.Model = lc
            this.Expiration = new Date(this.Model.Expiration!.year, this.Model.Expiration!.month - 1, this.Model.Expiration!.day);
        }
    }

    canSave() {
        return this.Model.Expiration && this.Model.NumeroLot && this.Model.Type && this.loadingAllAvailableConsommableFinished
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.prelevementList.forEach(async x => {
            await this.consommableRepository.attachConsommable(this.Model, (await this.prelevementRepository.getPrelevementEntityByCode(x.Code))!);
        })

        this.dialogRef.close(this.Model);
    }
}
